import { TEXT_PROPS } from './default-props';

// Mood Board Color
export const BG_PRIMARY = 'rgba(225,208,218,1)';
export const BG_SECONDARY = 'rgba(182,102,131,1)';
export const BG_ALTERNATIVE = 'rgba(248,239,214,1)';
export const BG_LAYER = 'rgba(248,235,216,0.44)';

// Text Color
export const TEXT_PRIMARY = 'rgba(139,69,139,1)';
export const TEXT_SECONDARY = 'rgba(139,42,59,1)';
export const TEXT_ALTERNATIVE = 'rgba(255,252,246,1)';

// Music & Navigation Color
export const NAVIGATION_COLOR = 'rgba(139,42,59,1)';
export const ICON_NAVIGATION_COLOR = 'white';

// Default Button Color
export const BUTTON_PROPS = {
  _hover: { opacity: '.8' },
};

export const BUTTON_PADDING_PROPS = {
  ...BUTTON_PROPS,
  ...TEXT_PROPS.body,
  variant: 'solid',
  padding: '18px 24px',
  borderRadius: '8px',
  background: 'bgSecondary',
  color: 'alternativeColorText',
  size: 'sm',
  boxShadow: 'sm',
  fontSize: '18px',
  position: 'relative',
  zIndex: '20',
};

export const DEFAULT_BUTTON_PROPS = {
  fontWeight: 'normal',
};
